<header class="simplified-header">
  <div class="logo">
    <img
      (click)="navigateToHomePage()"
      src="assets/imgs/psicogenius_with_border.png"
      alt="logo"
      class="img"
    />
  </div>
</header>
